import React from 'react';

// 정규표현식 특수문자를 이스케이프하는 함수
const escapeRegExp = string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const HighlightKeyword = ({ text, searchText, textStyle = {}, highlightStyle = { color: '#0567F9', fontWeight: 700 } }) => {
  if (!searchText) return text;

  // searchText를 이스케이프 처리하여 정규표현식 특수문자 문제 해결
  const escapedSearchText = escapeRegExp(searchText);
  const parts = text.split(new RegExp(`(${escapedSearchText})`, 'gi'));

  return parts.map((part, i) => {
    if (part.toLowerCase() === searchText.toLowerCase()) {
      return (
        <span key={i} style={{ ...textStyle, ...highlightStyle }}>
          {part}
        </span>
      );
    }
    return (
      <span key={i} style={textStyle}>
        {part}
      </span>
    );
  });
};

export default HighlightKeyword;
